import { colors } from '@material-ui/core';

export default {
  deletable: {
    '&:focus': {
      backgroundColor: colors.blueGrey[100]
    }
  },
  root: {
    backgroundColor: colors.blueGrey[50],
    color: colors.blueGrey[900]
  }
};
